import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'

import { defineEnvironmentDokuWiki } from '../../helpers/labels'
import { generalIcons } from '../../helpers/iconHelpers'
import CustomButton from '../../CustomButton'

const MakePreferredProfileModal = (props) => {
	const { profile, proferredProfile, onHide, onSave, loaderModal } = props;

	return (
		<Modal
			show
			onHide={onHide}
			className="config-modal modal-lg-size"
		>
			<Modal.Header>
				<Modal.Title id="contained-modal-title-lg" className="action-title">
					Make Preferred Profile
					<div className="header-question">
						<a
							href={`https://${defineEnvironmentDokuWiki()}/user:product:roscolive2.0:how_to_guide:fleet_administration:fleet_configuration`}
							target="_blank"
							title="What's this ?"
						>
							{generalIcons.headerQuestion}
						</a>
					</div>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="config-modal-body auto-height">
					<label>
						The current preferred profile is: <strong>{proferredProfile ? proferredProfile.name : 'N/A'}</strong>. <br />
						Would you like to make <strong>{profile.name}</strong> the preferred profile ?
					</label>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<div>
					<CustomButton variant="primary-outline" onClick={onHide}>
						No
					</CustomButton>
					<CustomButton variant="primary" onClick={onSave}>
						Yes
					</CustomButton>
				</div>
			</Modal.Footer>
			{loaderModal}
		</Modal>
	)
};

MakePreferredProfileModal.propTypes = {
	profile: PropTypes.objectOf(PropTypes.any).isRequired,
	proferredProfile: PropTypes.objectOf(PropTypes.any).isRequired,
	onHide: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
};

export default connect(
	state => ({
		loaderModal: state.loader.loaderModal
	}),
	dispatch => ({
		toggleLoaderModal: (show) => {
			dispatch({ type: 'TOGGLE_LOADER_MODAL', payload: show });
		}
	})
)(MakePreferredProfileModal);
